import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR';
const RETRY_DASHBOARD = 'RETRY_DASHBOARD';
export const SAVED_SEARCH_CLICKED = 'SAVED_SEARCH_CLICKED';

const initialState = {
  savedSearches: {},
  savedJobs: {},
  recommendedJobs: {},
  error: '',
  ready: false,
  expand: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RETRY_DASHBOARD: {
      return {
        ...state,
        error: '',
        ready: false,
        expand: false
      };
    }

    case GET_DASHBOARD_SUCCESS: {
      const { savedSearches = {}, savedJobs = {}, recommendedJobs = {} } = action.payload;

      return {
        ...state,
        savedSearches,
        savedJobs,
        recommendedJobs,
        ready: true,
        expand: true
      };
    }

    case GET_DASHBOARD_ERROR: {
      return {
        ...state,
        error: 'Sorry, your dashboard is currently unavailable.',
        ready: true,
        expand: false
      };
    }

    case SAVED_SEARCH_CLICKED: {
      const { index } = action.payload;
      const { data: previousData } = state.savedSearches;

      const data = previousData.map((search, i) => i === index ? { ...previousData[index], count: '0' } : search);

      const savedSearches = { ...state.savedSearches, ...{ data } };

      return {
        ...state,
        savedSearches
      };
    }

    default:
      return state;
  }
}

export const getDashboard = (locale, sessionId) => (dispatch, getState) => {
  const { user: { token } } = getState();

  return Promise.all([
    api.candidate.dashboard(locale, token),
    api.candidate.recommendedJobs(token, sessionId)
  ])
  .then(([ dashboard, recommendations ]) => {
    dispatch({
      type: GET_DASHBOARD_SUCCESS,
      payload: {
        ...dashboard,
        ...recommendations
      }
    });
  })
  .catch(error => {
    dispatch({
      type: GET_DASHBOARD_ERROR,
      error: true,
      payload: error
    });
  });
};

export const retry = () => dispatch => {
  dispatch({ type: RETRY_DASHBOARD });

  return dispatch(getDashboard());
};

export const savedSearchClicked = index => ({
  type: SAVED_SEARCH_CLICKED,
  payload: {
    index
  },
  meta: { hotjar: 'Dashboard Clicked Saved Search' }
});



/** WEBPACK FOOTER **
 ** ./app/store/dashboard/dashboard.js
 **/